import { useMutation } from '@tanstack/react-query'
import { searchCardApi } from '@!/Api/externalPayment'

/**
 * カード情報取得のカスタムフック
 * SearchCard APIを呼び出してカード情報を取得する
 * @returns {Object} カード情報取得関数とステート
 */
export const useSearchCard = () => {
  const mutation = useMutation({
    mutationFn: () => searchCardApi(),
  })

  return {
    searchCard: mutation.mutateAsync,
    isLoading: mutation.isPending,
  }
}
